import React from 'react';
import { Select } from 'antd';
import { GlobalVariable, MultiSelectSettings } from '@kemu-io/kemu-core/common/managers/globalVariables.js';
import { DataType, SupportedTypes } from '@kemu-io/hs-types';
import styles from '../GlobalVariablesPanel.module.css';
import { useTranslation } from '@hooks/index';
import classNames from 'classnames';

type Props = {
  variable: GlobalVariable;
  onChange: (name: string,value: SupportedTypes, type: DataType) => void;
}

/**
 * Multi-select control component for global variables
 * @param variable - The global variable configuration
 * @param onChange - Callback when value changes
 */
const MultiSelectControl = ({ variable, onChange }: Props) => {
  const settings = variable.controlSettings as MultiSelectSettings;
  const currentValue = variable.lastValue as string[] ?? [];
  const t = useTranslation('GlobalVariablesPanel');

  const handleChange = (value: string[]) => {
    onChange(variable.name, value, DataType.Array);
  };

  const options = settings.options.map(option => ({
    label: option,
    value: option,
  }));

  return (
    <Select
      mode="multiple"
      value={currentValue}
      onChange={handleChange}
      options={options}
      placeholder={t('MultiSelectControl.Placeholder')}
      className={classNames(styles.ControlSelect, styles.MultiSelectSelectRoot)}
      popupClassName={styles.DropdownSelectRoot}
      style={{ width: '100%' }}
    />
  );
};

export default MultiSelectControl;
